export const getGQLResult = async (appSyncClient, query, variables) => {
  const result = await appSyncClient.query({
    query,
    variables,
    fetchPolicy: 'network-only'
  });
  return result;
};
